import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { getOptimizedImage } from "@/lib/utils";

export const SplashScreen = () => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    // Hide the splash screen after 2.5 seconds
    const timer = setTimeout(() => {
      setIsVisible(false);
    }, 2500);
    return () => clearTimeout(timer);
  }, []);

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ opacity: 1 }}
          exit={{ opacity: 0, backdropFilter: "blur(0px)" }}
          transition={{ duration: 0.8, ease: "easeInOut" }}
          className="fixed inset-0 z-[999999] flex items-center justify-center bg-background/80 backdrop-blur-2xl"
        >
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            className="relative flex items-center justify-center p-10 md:p-14 rounded-3xl glass-panel overflow-hidden shadow-2xl shadow-primary/20"
          >
            {/* Shimmer Sweep Animation */}
            <motion.div
              initial={{ x: "-150%" }}
              animate={{ x: "250%" }}
              transition={{ 
                repeat: Infinity, 
                repeatDelay: 0.5,
                duration: 1.5, 
                ease: "easeInOut",
              }}
              className="absolute inset-0 z-20 w-1/2 h-full bg-gradient-to-r from-transparent via-white/40 to-transparent skew-x-[-25deg]"
            />
            
            {/* Glow Behind Logo */}
            <div className="absolute inset-0 bg-primary/20 blur-[50px] rounded-full" />
            
            {/* Logo */}
            <motion.img 
              src={getOptimizedImage("https://vibe.filesafe.space/1777452152224543148/attachments/b2d87f8c-867e-42ac-879f-3479ff2d859b.png", 128, 128)} 
              alt="Logo" 
              className="w-24 h-24 md:w-32 md:h-32 object-contain relative z-10 mb-2"
            />
            
            {/* Loading Bar */}
            <div className="absolute bottom-0 left-0 w-full h-1.5 bg-white/5">
              <motion.div 
                initial={{ width: "0%" }}
                animate={{ width: "100%" }}
                transition={{ duration: 2.3, ease: "easeInOut" }}
                className="h-full bg-primary shadow-[0_0_10px_hsl(var(--primary))]"
              />
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

